module.exports = __webpack_public_path__ + "img/dgd_no_activity_banner_new.325253c0.png";